import { OTA_UniqueID } from "./ota_uniqueid.model";

export class OTA_VehCancelRQCore {
    public uniqueID = new OTA_UniqueID();
}